module.exports = __webpack_public_path__ + "media/images/sp/visit_reservations_enpou/flow_02-bc33dafc465d9730bde4c96db6102afd.jpg";